import React, {

  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Header3 from "../../components/Header3";
import { Form, Modal } from "react-bootstrap";
import axios from "../../AxiosInstance";
import { ChatState } from "../../context/ChatProvider";
import toast from "react-hot-toast";
import Footer2 from "../../components/Footer2";
import { LanguageContext } from "../../context/LanguageContext";
import { useNavigate, useParams } from "react-router-dom";
import { BsQuestionCircleFill } from "react-icons/bs";
import { max } from "moment";
import { fromZonedTime } from "date-fns-tz";
import Spinner from "react-bootstrap/Spinner";
import { ChevronDown } from "lucide-react";
import { resolveBookImageUrl } from "../../utils/urlHelpers";

const BooksDetails = () => {
  const navigate = useNavigate();
  const itemRefs = useRef([]);

  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const { lg } = useContext(LanguageContext);
  const { user } = ChatState();
  
  // Scroll to top when component mounts (especially important for mobile)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const [show, setShow] = useState(false); // For signup modal
  const handleClose = () => {
    setShow(false); // Close signup modal
    navigate("/leading"); // Navigate to home page
  };
  // Handle opening signup modal
  const handleShow = () => {
    setShow(true); // Open signup modal
  };

  const [selectedDay, setSelectedDay] = useState("");
  const handleDateChange = (e) => {
    const day = e.target.value;
    if (day) {
      const selectedDate = new Date(2024, 9, day);
      const weekDay = selectedDate.toLocaleString("en-US", { weekday: "long" });
      setSelectedDay(weekDay);
    } else {
      setSelectedDay("");
    }
  };

  const [eventType, setEventType] = useState(""); // State to track selected option
  const [eventLocation, setEventLocation] = useState("");
  const [eventLink, setEventLink] = useState("");
  // ✅ Step 1: Load event data from localStorage when page loads

  const [showB, setShowB] = useState(false); // For signup modal
  const handleCloseB = () => {
    setShowB(false);
  };
  const handleShowB = () => {
    setShowB(true); // Open  modal
  };
  const [selectedImagemodel, setSelectedImagemodel] = useState(null);
  const [imageName, setImageName] = useState("");

  // پیج لوڈ ہونے پر لوکل اسٹوریج سے تصویر حاصل کریں
  useEffect(() => {
    const storedImage = localStorage.getItem("uploadedImagemodelaaaa");
    const storedImageName = localStorage.getItem("uploadedImageNamenew");

    if (storedImage && storedImageName) {
      setSelectedImagemodel(storedImage);
      setImageName(storedImageName);
    }
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // یوزر کی منتخب کردہ فائل
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setSelectedImagemodel(fileURL);
      setImageName(file.name);

      // لوکل اسٹوریج میں تصویر اور اس کا نام محفوظ کریں
      localStorage.setItem("uploadedImagemodelaaaa", fileURL);
      localStorage.setItem("uploadedImageNamenew", file.name);
      setModalDate({ ...modalData, image: file });
    }
  };
  const [modalData, setModalDate] = useState({
    image: null,
    title: "",
    writer: "",
    genre: "",
    aboutBook: "",
  });
  const handleModalInputChange = (e) => {
    const { name, value } = e.target;
    setModalDate((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  // Load the selected image from localStorage on component mount
  useEffect(() => {
    const storedImage = localStorage.getItem("createImagesss");
    if (storedImage) {
      setSelectedImage(storedImage);
    }
  }, []);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result); // Set the selected image as a base64 URL
        localStorage.setItem("createImagesss", reader.result); // Save to localStorage
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // 0-based (Jan = 0)
  const currentYear = currentDate.getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear + i);

  // const DateSelector = () => {
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedYear, setSelectedYear] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [weekday, setWeekday] = useState("");

  const [selectedDays, setSelectedDays] = useState("");
  /**
   * Get available months for a given year.
   */
  const getAvailableMonths = (selectedYear) => {
    if (parseInt(selectedYear) === currentYear) {
      // If it's the current year, show only future months (including current month)
      return months.slice(currentMonth);
    } else {
      // For future years, show all months
      return months;
    }
  };
  const availableMonths = getAvailableMonths(selectedYear);

  // Automatically update day when date, month, and year are selected
  useEffect(() => {
    if (selectedDate && selectedMonth && selectedYear) {
      const monthIndex = months.indexOf(selectedMonth);
      const selectedFullDate = new Date(selectedYear, monthIndex, selectedDate);

      const today = new Date();
      today.setHours(0, 0, 0, 0); // remove time component

      // ✅ Prevent past dates
      if (selectedFullDate < today) {
        toast.error("You cannot select a past date!");
        setSelectedDate("");
        setSelectedMonth("");
        setSelectedYear("");
        setSelectedDays("");
        return;
      }

      setSelectedDays(daysOfWeek[selectedFullDate.getDay()]);
    }
  }, [selectedDate, selectedMonth, selectedYear]);
  //
  const handleDateChanges = () => {
    if (selectedDays && selectedMonth !== "" && selectedYear) {
      const monthIndex = months.indexOf(selectedMonth); // Convert month to index
      const date = new Date(selectedYear, monthIndex, selectedDays);
      setWeekday(daysOfWeek[date.getDay()]); // Get day name
    }
  };
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsCity, setSuggestionsCity] = useState([]);

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loading, setLoading] = useState(false);
  const timeoutRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const fetchSuggestions = async (searchQuery) => {
    if (!searchQuery.trim()) {
      setSuggestions([]);
      return;
    }
    setModalDate({ showImage: false });
    setLoading(true);
    try {
      const res = await axios.get(
        `/api/search?query=${encodeURIComponent(searchQuery)}`
      );
      // Map the API response to match your data structure
      const formattedBooks = res.data?.books?.map((book) => ({
        id: book.EAN,
        title: book["Title Derived"],
        author: book["First Contributor Name"],
        format: book["Product Form Description"],
        publisher: book["Publisher Imprint"],
        genre: book["1st BISAC Major Description"],
        pageNumber: book["Page Number"],
        aboutBook: book["AboutBook"],

        image: book.image,
      }));
      setSuggestions(formattedBooks);
      setShowSuggestions(true);
    } catch (err) {
      console.error("Search error:", err);
      setSuggestions([]);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      fetchSuggestions(value);
    }, 300);
  };

  const handleBookClick = (book) => {
    // Save the complete book data to localStorage
    setSelectedBook(book);
    setQuery(book.title);
    setShowSuggestions(false);
    // Optional: Trigger any parent component callback or state update
  };
  // Frontend API call example
  const addBookManually = async () => {
    setSelectedBook({
      title: modalData.title,
      author: modalData.writer,
      genre: modalData.genre,
      aboutBook: modalData.aboutBook || "",
    });

    const formData = new FormData();

    // Append text fields
    formData.append("title", modalData.title);
    formData.append("writer", modalData.writer);
    formData.append("genre", modalData.genre);
    formData.append("description", modalData.aboutBook || "");

    // Append image if exists
    if (modalData.image) {
      formData.append("image", modalData.image);
    }

    try {
      const response = await axios.post("/api/v1/books/manual-add", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Important for file uploads
        },
      });
      console.log(response, "ddd");

      setModalDate({
        image: null,
        title: "",
        writer: "",
        genre: "",
        aboutBook: "",
        showImage: true,
        link: response.data?.data.coverImage, 
      });

      handleCloseB();
      return response.data;
    } catch (error) {
      console.error("Error adding book:", error);

      // Enhanced error handling
      let errorMessage = "Failed to add book";
      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data?.message || errorMessage;

        // Handle validation errors if available
        if (error.response.data?.errors) {
          errorMessage = Object.values(error.response.data.errors).join("\n");
        }
      } else if (error.request) {
        // Request was made but no response
        errorMessage = "Network error - please check your connection";
      }

      // Show pretty toast notification
      toast.error(errorMessage);
    }
  };
  const [eventAddress, setEventAddress] = useState("");
  const [visibility, setVisibility] = useState("");
  const [eventDetails, setEventDetails] = useState("");
  const [eventTime, setEventTime] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCityObj, setSelectedCityObj] = useState(null);
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");

  const handleInputChangeCity = async (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (value.trim() !== "") {
      try {
        const response = await axios.get(
          `/api/v1/books/books/searchCity?query=${encodeURIComponent(value)}`
        );

        if (response.data.success && Array.isArray(response.data.data)) {
          setSuggestionsCity(response.data.data); // Show city suggestions
        } else {
          setSuggestionsCity([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestionsCity([]);
      }
    } else {
      setSuggestionsCity([]); // Reset suggestions when input is empty
    }
  };

  const handleSuggestionClick = (cityObj) => {
    console.log("Selected city:", cityObj.city);
    console.log("Selected country:", cityObj.country);

    setCity(cityObj.city); // Set the selected city
    setCountry(cityObj.country); // Set the selected country
    setSearchQuery(`${cityObj.city}, ${cityObj.country}`); // Set searchQuery to both city and country
    setSelectedCityObj(cityObj);
    setSuggestionsCity([]); // Hide suggestions after selection
  };
  const [ageRanges, setAgeRanges] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedAge, setSelectedAge] = useState("");
  const [selectedMaxAge, setSelectedMaxAge] = useState("");

  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [loadingMen, setLoadingMen] = useState(false);
  const [error, setError] = useState(null);
  const [selectedBook, setSelectedBook] = useState(null);
  const [book, setBook] = useState({});
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const handleMaxChange = (e) => {
    setMaxValue(e.target.value);
  };
  const handleMinChange = (e) => {
    setMinValue(Number(e.target.value));
    setMaxValue(""); // Reset maxValue when minValue changes
  };

  const { id } = useParams();

  const joinedAge = `${selectedAge}-${selectedMaxAge}`; // e.g. "10-16"

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/v1/books/${id}`)
        .then((res) => {
          const data = res.data;
          setBook(data); // If needed
          setSelectedBook(data);
          const [minAge, maxAge] = data.age?.split("-") || ["", ""];
          setSelectedAge(minAge);
          setSelectedMaxAge(maxAge);

          setSelectedLanguage(data.language);
          setEventType(data.type);
          setEventDetails(data.description);
          setSelectedMonth(data.dateInfo?.month || ""); // already working
          setSelectedYear(data.dateInfo?.year || ""); // already working
          setSelectedDays(data.dateInfo?.dayName || ""); // weekday (optional)
          setSelectedDate(
            data.dateInfo?.day?.toString().padStart(2, "0") || ""
          );
          setEventTime(
            data.timeTrack?.minutes?.toString().padStart(2, "0") || ""
          );
          setVisibility(
            data.timeTrack?.seconds?.toString().padStart(2, "0") || ""
          );

          setSearchQuery(data.city);

          setSelectedCityObj({
            city: data.city,
            country: data.country,
            latitude: data.lati,
            longitude: data.langi,
          });
          setEventLocation(data.location?.name || "");
          setEventAddress(data.location?.address || "");
          setEventLink(data.meetingLink || "");
          setMaxValue(data.maxAttendee || "");
          setMinValue(data.minAttendee || "");

        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch age ranges
        const ageResponse = await axios.get(`/api/v1/stores/age`);
        setAgeRanges(ageResponse.data.data);

        // Fetch languages
        const langResponse = await axios.get(`/api/v1/stores/lang`);
        setLanguages(langResponse.data.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (highlightedIndex >= 0 && itemRefs.current[highlightedIndex]) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);
  const handleSuggestionClickName = (book) => {
    const selectedBookObj = {
      bookId: undefined, // 👈 Use book.id if available
      bookCoverImage: book.image, // <== This is correct
      title: book.title,
      author: book.author,
      descriptions: book.aboutBook, // ✅ add this
      titless: book.title,
      publisher: book.publisher,
      book: book,
      EAN: book.id, // 👈 Add EAN if available
      isSearchBook: true, // 👈 Add this if coming from searchbook
    };

    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    );
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    );
    navigate(`/reviews?ean=${book.id}&searchbook=true`);
  };
  const handleCreateEvent = async () => {
    try {
      const monthMap = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };

      const paddedMonth = monthMap[selectedMonth] ?? "01"; // Convert month name to 2-digit format
      const paddedDate = selectedDate.padStart(2, "0");
      const paddedSeconds = visibility.padStart(2, "0"); // assuming visibility is seconds
      const dateTimeStr = `${selectedYear}-${paddedMonth}-${paddedDate}T${eventTime}:${visibility}:00`; // e.g. "2025-07-11T18:00:00"
      const organizerTimeZone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;

      const eventTimeInOrganizerZone = fromZonedTime(
        dateTimeStr,
        organizerTimeZone
      );

      // 1. Validate and build payload
      const payload = {
        title: selectedBook?.title,
        pageNumber: selectedBook?.pageNumber,
        name: "Book Club",
        // aboutBook: selectedBook?.aboutBook, // ✅ CSV se mila hua data
        author: selectedBook?.author,
        aboutBook: selectedBook?.aboutBook,
        genre: selectedBook?.genre,
        // age: selectedAge,
        age: joinedAge,
        language: selectedLanguage,
        type: eventType,
        description: eventDetails,
        userId: user?._id, // You need to get this from auth
        dateInfo: {
          day: selectedDate,
          month: selectedMonth,
          year: selectedYear,
          dayName: selectedDays,
        },
        timeTrack: {
          minutes: eventTime,
          seconds: visibility,
        },
        email: user?.email,
        globalTime: eventTimeInOrganizerZone.toISOString(), // accurate UTC
        timeZone: organizerTimeZone, // e.g. "Asia/Karachi"
        city: selectedCityObj?.city, // ✅ Use from selectedCityObj
        country: selectedCityObj?.country, // ✅ Optional if needed
        lati: selectedCityObj?.latitude, // ✅ Accurate location
        langi: selectedCityObj?.longitude,
        maxAttendee: maxValue,
        minAttendee: minValue,
        EAN: selectedBook?.id,
        image: modalData?.showImage
          ? modalData?.link
          : `${selectedBook?.image}`,
        ...(eventType === "In-person" && {
          location: {
            name: eventLocation,
            address: eventAddress,
            coordinates: [
              selectedCityObj?.longitude ?? 0, // ✅ longitude first
              selectedCityObj?.latitude ?? 0, // ✅ then latitude
            ],
          },
        }),
        ...(eventType === "On-line" && {
          meetingLink: eventLink,
        }),
      };

      // 2. Check for any missing required fields
      const requiredFields = {
        Title: payload.title,
        Author: payload.author,
        Age: payload.age,
        minAttendee: minValue,
        maxAttendee: maxValue,
        Language: payload.language,
        "Event Type": payload.type,
        Description: payload.description,
        "Date (day)": payload.dateInfo.day,
        "Date (month)": payload.dateInfo.month,
        "Date (year)": payload.dateInfo.year,
        "Time (minutes)": payload.timeTrack.seconds,
        "Time (hours)": payload.timeTrack.minutes,
        "Image URL": payload.image,
        ...(payload.type === "In-person" && {
          "Location Name": payload.location?.name,
          "Location Address": payload.location?.address,
          City: payload.city,
        }),
        ...(payload.type === "On-line" && {
          "Meeting Link": payload.meetingLink,
        }),
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([_, value]) => !value)
        .map(([field]) => field);

      if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }

      // 3. Make API call with Axios
      const response = await axios.post("/api/v1/books/addbooks", payload, {
        headers: {
          "Content-Type": "application/json",
          // Add if using authentication:
          // 'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      });

      // 4. Handle success
      toast.success("Book event created successfully!");
      console.log("Created book:", response.data);
      handleShow(true);
      setSelectedDays("");
      setImageName("");
      setSelectedDate("");
      setSelectedMonth("");
      setSelectedYear("");
      setEventLocation("");
      setIsSubmitting(false);
      localStorage.removeItem("uploadedImagemodelaaaa");
      // navigate(`/book/${response.data._id}`); // Uncomment if you want to redirect
    } catch (error) {
      // 5. Handle errors
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to create book event";
      toast.error(errorMessage);
      console.error("Creation error:", error);
      setIsSubmitting(false);

      // Optional: Scroll to top to show error message
      window.scrollTo(0, 0);
    }
  };
  if (loadingMen) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // Update Book detail

  const handleUpdateBook = async (bookId) => {
    const monthMap = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    const paddedMonth = monthMap[selectedMonth] ?? "01"; // Convert month name to 2-digit format
    const paddedDate = selectedDate.padStart(2, "0");
    const paddedSeconds = visibility.padStart(2, "0"); // assuming visibility is seconds
    const dateTimeStr = `${selectedYear}-${paddedMonth}-${paddedDate}T${eventTime}:${visibility}:00`; // e.g. "2025-07-11T18:00:00"
    const organizerTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const eventTimeInOrganizerZone = fromZonedTime(
      dateTimeStr,
      organizerTimeZone
    );
    try {
      const payload = {
        title: selectedBook?.title,
        pageNumber: selectedBook?.pageNumber,
        name: "Book Club",
        globalTime: eventTimeInOrganizerZone.toISOString(), // accurate UTC
        timeZone: organizerTimeZone,
        author: selectedBook?.author,
        genre: selectedBook?.genre,
        // age: selectedAge,
        age: joinedAge,
        language: selectedLanguage,
        type: eventType,
        description: eventDetails,
        maxAttendee: maxValue,
        minAttendee: minValue,
        userId: user?._id,
        dateInfo: {
          day: selectedDate,
          month: selectedMonth,
          year: selectedYear,
          dayName: selectedDays,
        },
        timeTrack: {
          minutes: eventTime,
          seconds: visibility,
        },
        email: user?.email,
        city: selectedCityObj?.city,
        country: selectedCityObj?.country,
        lati: selectedCityObj?.latitude,
        langi: selectedCityObj?.longitude,
        image: modalData?.showImage
          ? modalData?.link
          : `${selectedBook?.image}`,
        ...(eventType === "In-person" && {
          location: {
            name: eventLocation,
            address: eventAddress,
            coordinates: [
              selectedCityObj?.longitude ?? 0,
              selectedCityObj?.latitude ?? 0,
            ],
          },
        }),
        ...(eventType === "On-line" && {
          meetingLink: eventLink,
        }),
      };

      // Validate fields
      const requiredFields = {
        Title: payload.title,
        Author: payload.author,
        Age: payload.age,
        Language: payload.language,
        Description: payload.description,

        "Event Type": payload.type,
        "Date (day)": payload.dateInfo.day,
        "Date (month)": payload.dateInfo.month,
        "Date (year)": payload.dateInfo.year,
        "Time (minutes)": payload.timeTrack.minutes,
        "Time (hours)": payload.timeTrack.seconds,
        minAttendee: minValue,
        maxAttendee: maxValue,
        "Image URL": payload.image,
        ...(payload.type === "In-person" && {
          "Location Name": payload.location?.name,
          "Location Address": payload.location?.address,
          City: payload.city,
        }),
        ...(payload.type === "On-line" && {
          "Meeting Link": payload.meetingLink,
        }),
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([_, value]) => !value)
        .map(([field]) => field);

      if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
      }

      // PUT request for update
      const response = await axios.put(
        `/api/v1/books/updatebook/${bookId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Book updated successfully!");
      console.log("Updated book:", response.data);

      // Optional reset
      handleShow(true);
      setSelectedDays("");
      setImageName("");
      setSelectedDate("");
      setSelectedMonth("");
      setSelectedYear("");
      setEventLocation("");
      localStorage.removeItem("uploadedImagemodelaaaa");
      setIsSubmitting(false);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to update book";
      toast.error(errorMessage);
      console.error("Update error:", error);
      setIsSubmitting(false);
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <div className="hederwbokd">
        <Header3 />
      </div>
      <div className="container mx-auto px-4 lg:!px-0 py-6">
        <div className="max-w-6xl mx-auto">
          {/* Book Image and Search Section */}
          <div className="flex flex-col lg:flex-row gap-6 mb-8">
            {/* Book Cover */}
            <div className="w-full max-w-[180px] mx-auto lg:mx-0 lg:w-64 lg:max-w-none flex-shrink-0">
              <div className="bg-gray-100 rounded-xl shadow-sm border border-gray-200 w-full aspect-[2/3] flex items-center justify-center overflow-hidden relative">
                {selectedBook?.image || modalData?.showImage ? (
                  <img
                    onClick={() => handleSuggestionClickName(selectedBook)}
                    src={
                      modalData?.showImage
                        ? selectedImagemodel
                        : resolveBookImageUrl(selectedBook?.image)
                    }
                    alt={selectedBook?.title || "Book cover"}
                    className="w-full h-full object-cover cursor-pointer"
                  />
                ) : (
                  <div className="text-gray-400 text-center p-6">
                    <svg className="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                    <p className="text-sm">No book selected</p>
                  </div>
                )}
              </div>
            </div>

            {/* Book Search and Info */}
            <div className="flex-1 space-y-4">
              {/* Book Club Badge */}
              <div className="inline-block px-4 py-2 bg-[#DBECD0] rounded-lg text-dark font-semibold text-base">
                BOOK CLUB
              </div>

              {/* Book Search */}
              <div className="relative">
                <input
                  type="text"
                  placeholder={lg?.serchbook || "Search book..."}
                  value={query}
                  onChange={handleInputChange}
                  onFocus={() => setShowSuggestions(true)}
                  onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowDown") {
                      setHighlightedIndex((prev) =>
                        prev < suggestions.length - 1 ? prev + 1 : 0
                      );
                    } else if (e.key === "ArrowUp") {
                      setHighlightedIndex((prev) =>
                        prev > 0 ? prev - 1 : suggestions.length - 1
                      );
                    } else if (e.key === "Enter" && highlightedIndex >= 0) {
                      handleBookClick(suggestions[highlightedIndex]);
                      setShowSuggestions(false);
                    }
                  }}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900"
                />

                {showSuggestions && (
                  <div className="absolute w-full mt-1 max-h-80 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                    {loading ? (
                      <div className="p-3 text-gray-500 text-center">Loading...</div>
                    ) : suggestions.length > 0 ? (
                      suggestions.map((book, index) => (
                        <div
                          key={book.id}
                          ref={(el) => (itemRefs.current[index] = el)}
                          className={`flex items-center gap-3 p-3 cursor-pointer border-b border-gray-100 last:border-b-0 hover:bg-gray-50 ${
                            index === highlightedIndex ? "bg-[#34C3C9] text-white" : ""
                          }`}
                          onClick={() => handleBookClick(book)}
                        >
                          {book.image && (
                            <img
                              src={
                                resolveBookImageUrl(book?.image)
                              }
                              alt={book.title}
                              className="w-8 h-12 object-cover rounded"
                            />
                          )}
                          <div className="flex-1 min-w-0">
                            <div className="font-semibold truncate">{book.title}</div>
                            <div className="text-sm text-gray-600 truncate">
                              {book.author} • {book.publisher}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : query ? (
                      <div className="p-3 text-gray-500 text-center">No results found</div>
                    ) : null}
                  </div>
                )}

                <button
                  onClick={handleShowB}
                  className="mt-2 text-sm text-[#34C3C9] hover:text-[#2BB3BA] underline transition-colors"
                >
                  {lg?.DidText || "Did not find your book? Enter details!"}
                </button>
              </div>

              {/* Book Info (Read-only) */}
              <div className="space-y-3">
                <input
                  type="text"
                  value={selectedBook?.title || ""}
                  readOnly
                  className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-gray-700 font-semibold"
                />
                <input
                  type="text"
                  value={selectedBook?.author || ""}
                  readOnly
                  className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-gray-700 font-medium"
                />
                <input
                  type="text"
                  value={selectedBook?.genre || ""}
                  readOnly
                  className="w-full px-4 py-2.5 bg-gray-100 border border-gray-200 rounded-lg text-gray-700 font-medium"
                />
              </div>
            </div>
          </div>

          {/* Form Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Date Selection */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.when || "When"}
                </label>
                <div className="grid grid-cols-3 gap-2">
                  <div className="relative">
                    <select
                      onChange={(e) => setSelectedDate(e.target.value)}
                      value={selectedDate || ""}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">{lg?.day || "Day"}</option>
                    {Array.from({ length: 31 }, (_, i) => {
                      const value = (i + 1).toString().padStart(2, "0");
                      return (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      );
                    })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      value={selectedMonth || ""}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">{lg?.month || "Month"}</option>
                    {availableMonths.map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      onChange={(e) => setSelectedYear(e.target.value)}
                      value={selectedYear || ""}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">{lg?.year || "Year"}</option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
                {selectedDays && (
                  <div className="mt-2 px-3 py-1.5 bg-[#34C3C91a] text-[#34C3C9] rounded-lg text-sm font-medium inline-block">
                    {selectedDays}
                  </div>
                )}
              </div>

              {/* Time Selection */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.time || "Time"}
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <div className="relative">
                    <select
                      value={eventTime || ""}
                      onChange={(e) => setEventTime(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">{lg?.hour || "Hour"}</option>
                    {Array.from({ length: 24 }, (_, i) => {
                      const value = i.toString().padStart(2, "0");
                      return (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      );
                    })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      value={visibility || ""}
                      onChange={(e) => setVisibility(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">{lg?.min || "Min"}</option>
                    {Array.from({ length: 60 }, (_, i) => {
                      const value = i.toString().padStart(2, "0");
                      return (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      );
                    })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
              </div>

              {/* Event Type */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.type || "Type"}
                </label>
                <div className="relative">
                  <select
                    value={eventType || ""}
                    onChange={(e) => setEventType(e.target.value)}
                    className="w-full pl-4 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                    style={{ paddingRight: "2.5rem" }}
                  >
                    <option value="">{lg?.selectType || "Select Type"}</option>
                    <option value="In-person">{lg?.inPerson || "In-person"}</option>
                    <option value="On-line">On-line</option>
                  </select>
                  <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                </div>
              </div>

              {/* Location Fields (In-person) */}
              {eventType === "In-person" && (
                <>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      City
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder={lg?.city || "City"}
                        value={searchQuery}
                        onChange={handleInputChangeCity}
                        required
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 text-sm"
                      />
                      {isLoading && (
                        <div className="absolute top-3 right-3">
                          <div className="spinner-border text-[#34C3C9] spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                      {suggestionsCity?.length > 0 && (
                        <ul className="absolute w-full mt-1 max-h-48 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                          {suggestionsCity?.map((suggestion, index) => (
                            <li
                              key={index}
                              className="px-4 py-2 cursor-pointer hover:bg-gray-50 border-b border-gray-100 last:border-b-0 text-sm"
                              onClick={() => handleSuggestionClick(suggestion)}
                            >
                              {suggestion.city}, {suggestion.country}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.venue || "Venue"}
                    </label>
                    <input
                      type="text"
                      placeholder={lg?.venue || "Venue"}
                      value={eventLocation}
                      onChange={(e) => setEventLocation(e.target.value)}
                      required
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      {lg?.address || "Address"}
                    </label>
                    <input
                      type="text"
                      placeholder={lg?.address || "Address"}
                      value={eventAddress}
                      onChange={(e) => setEventAddress(e.target.value)}
                      required
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 text-sm"
                    />
                  </div>
                </>
              )}

              {/* Meeting Link (On-line) */}
              {eventType === "On-line" && (
                <div className="md:col-span-2">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Meeting Link
                  </label>
                  <input
                    type="text"
                    placeholder={lg?.onlink || "Add link to the video call (Teams, Zoom, Google Meet, Skype etc.)"}
                    value={eventLink}
                    onChange={(e) => setEventLink(e.target.value)}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 text-sm"
                  />
                </div>
              )}

              {/* Age Range */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.agerg || "Age range"}
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <div className="relative">
                    <select
                      value={selectedAge || ""}
                      onChange={(e) => setSelectedAge(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">Min</option>
                    {Array.from({ length: 90 - 18 + 1 }, (_, i) => {
                      const age = i + 18;
                      return (
                        <option key={age} value={age}>
                          {age}
                        </option>
                      );
                    })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      value={selectedMaxAge || ""}
                      onChange={(e) => setSelectedMaxAge(e.target.value)}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">Max</option>
                    <option value="no-limit">No Limit</option>
                    {[...Array(90)]
                      .map((_, i) => i + 2)
                      .filter((val) => val > selectedAge)
                      .map((val) => (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
              </div>

              {/* Language */}
              <div>
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                  {lg?.language || "Language"}
                  <div className="relative group">
                    <BsQuestionCircleFill className="text-gray-400 cursor-help" size={14} />
                    <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                      {lg?.languageTooltipBookClub || "This is the language participants will speak during Book Club."}
                    </div>
                  </div>
                </label>
                <div className="relative">
                  <select
                    value={selectedLanguage || ""}
                    onChange={(e) => setSelectedLanguage(e.target.value)}
                    className="w-full pl-4 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                    style={{ paddingRight: "2.5rem" }}
                  >
                  <option value="">{lg?.selectLanguage || "Select Language"}</option>
                  {languages.map((language) => (
                    <option key={language._id} value={language.code}>
                      {language.name}
                    </option>
                    ))}
                  </select>
                  <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                </div>
              </div>

              {/* Attendees */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  {lg?.attendees || "Attendees"}
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <div className="relative">
                    <select
                      value={minValue || ""}
                      onChange={handleMinChange}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">Min</option>
                    {[...Array(49)].map((_, i) => {
                      const val = i + 2;
                      return (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      );
                    })}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                  <div className="relative">
                    <select
                      value={maxValue || ""}
                      onChange={handleMaxChange}
                      className="w-full pl-3 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 bg-white text-sm appearance-none"
                      style={{ paddingRight: "2.5rem" }}
                    >
                    <option value="">Max</option>
                    <option value="no-limit">No Limit</option>
                    {[...Array(98)]
                      .map((_, i) => i + 2)
                      .filter((val) => val > minValue)
                      .map((val) => (
                        <option key={val} value={val}>
                          {val}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
                  </div>
                </div>
              </div>
            </div>

            {/* Details - Full Width */}
            <div className="mt-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                {lg?.detil || "Details"}
              </label>
              <textarea
                value={eventDetails}
                onChange={(e) => setEventDetails(e.target.value)}
                required
                rows={4}
                placeholder={lg?.eventDetails || "Enter event details..."}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34C3C9] focus:border-[#34C3C9] outline-none transition-all text-gray-900 resize-none text-sm"
                style={{ whiteSpace: "pre-wrap" }}
              />
            </div>

            {/* Submit Button */}
            <div className="flex justify-end pt-4 border-t border-gray-200">
              <button
                onClick={async () => {
                  if (isSubmitting) return;
                  setIsSubmitting(true);
                  try {
                    if (id) {
                      await handleUpdateBook(id);
                    } else {
                      await handleCreateEvent();
                    }
                  } catch (err) {
                    console.error(err);
                  }
                }}
                disabled={isSubmitting}
                className="px-8 py-3 bg-[#34C3C9] hover:bg-[#2BB3BA] text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isSubmitting ? (
                  <>
                    <Spinner animation="border" size="sm" className="text-white" />
                    <span>{id ? "Updating..." : "Publishing..."}</span>
                  </>
                ) : id ? (
                  "Update"
                ) : (
                  lg?.publsbtn || "Publish"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete msg */}

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="customdeldetl "
      >
        <Modal.Header className=" border-0  ">
          <img
            className=" border-0 closebtn  closebokde "
            src={require("../../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 mx-4 text-dark fw-bold mb-4 mt-auto mt-sm-3 mb-sm-5 ftnotfi"
          style={{
            fontSize: "26px",
            lineHeight: "43.58px",
          }}
        >
          {lg?.bookclubLive ||
            "Well done! Your Bookclub is now live and people can join it."}
        </Modal.Title>
      </Modal>

      {/* DID NOT MODEL */}
      <Modal
        show={showB}
        onHide={handleCloseB}
        centered
        className="custom-modalmeet"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtn "
            src={require("../../components/image/close.png")}
            alt="logo"
            onClick={handleCloseB}
          />
        </Modal.Header>
        <Modal.Title className="text-center mt-sm-3 "></Modal.Title>
        <Modal.Body className="mx-auto mlminmodel mt-sm-3 mt-1">
          <div className="d-flex mt-4 ">
            <div className="text-dark ftzevtt fw-bold fs-5 col-sm-3 col-3 mx-md-5 mx-sm-4 mx-2">
              {lg?.booksCover || "Book's Cover"}:
            </div>
            <div>
              {/* Hidden File Input */}
              <input
                type="file"
                accept="image/*"
                id="fileInput"
                style={{ display: "none" }}
                onChange={handleImageUpload}
              />

              <button
                className=" fw600"
                style={{
                  fontSize: "18px",
                  width: "151px",
                  height: "38px",
                  border: "2px solid #34C3C9",
                  color: "#5B5B5B",

                  cursor: "pointer",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                onClick={() => document.getElementById("fileInput").click()}
              >
                {imageName
                  ? imageName.substring(0, 7) +
                    (imageName.length > 7 ? "..." : "")
                  : lg?.upload || "Upload"}
              </button>
              {/* {imageName && <p style={{ marginTop: "10px" }}>📁 {imageName}</p>} */}
              {/* Image Preview */}
              {selectedImagemodel && (
                <div className="d-none" style={{ marginTop: "10px" }}>
                  <img
                    src={selectedImagemodel}
                    alt="Preview"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </div>
            <div
              className="fw600 ftzevtt d-sm-block d-none mx-md-5 mx-3 my-1"
              style={{ color: "#2B2B2B", fontSize: "18px" }}
            >
              ({lg?.optnal || "Optional"})
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark fw-bold col-sm-3  col-3 ftzevtt fs-5 mx-md-5 mx-sm-4 mx-2">
              {lg?.title || "Title"}:
            </div>

            <div className="">
              <input
                type="text"
                className="form-control modeltextwid widmeetupin fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="text"
                value={modalData.title}
                name="title"
                onChange={handleModalInputChange}
                required
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  height: "38px",
                }}
              />
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark ftzevtt fw-bold col-sm-3 col-3 fs-5 mx-md-5 mx-sm-4 mx-2">
              {lg?.writerLabel || lg?.writer || "Writer"}:
            </div>

            <div className="">
              <input
                type="text"
                value={modalData.writer}
                name="writer"
                onChange={handleModalInputChange}
                className="form-control modeltextwid widmeetupin  fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="text"
                required
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  height: "38px",
                }}
              />
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark fw600 ftzevtt col-sm-3 col-3 fs-5 mx-md-5 mx-sm-4 mx-2">
              {lg?.genreLabel || lg?.genre || "Genre"}:
            </div>

            <div className="">
              <Form.Select
                className="form-control modeltextwid  widmeetupin text-dark fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="visibilitySelect"
                // value={visibility}
                // onChange={(e) => setVisibility(e.target.value)}
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  // height: "40px",
                }}
                value={modalData.genre}
                name="genre"
                onChange={handleModalInputChange}
              >
                <option value="Genre">{lg?.genreLabel || lg?.genre || "Genre"}</option>
                <option value="Crime">{lg?.cri || "Crime"}</option>
                <option value="Fiction">{lg?.fic || "Fiction"}</option>
                <option value="Graphic Novels & Manga">
                  {lg?.grpnvl || "Graphic Novels & Manga"}
                </option>
                <option value="Non-Fiction">{lg?.nonfic || "Non-Fiction"}</option>
                <option value="Sci-Fi & Fantasy">{lg?.scifan || "Sci-Fi & Fantasy"}</option>
                <option value="Young Adults & LGBTQ+">
                  {lg?.yng || "Young Adults & LGBTQ+"}
                </option>
              </Form.Select>
            </div>
          </div>

          <div className="d-flex mt-3 ">
            <div className="text-dark fw600 ftzevtt col-sm-3 col-3 fs-5 mx-md-5 mx-sm-4 mx-2">
              {lg?.aboutbook || "About the book"}:
            </div>

            <div className="">
              <textarea
                className="form-control modeltextwid widmeetupin fw600 fs-5 ftzevtt rounded-1 placeholder-login"
                id="aboutBook"
                value={modalData.aboutBook}
                name="aboutBook"
                onChange={handleModalInputChange}
                rows="4"
                style={{
                  border: "2px solid #3C3C3C",
                  width: "388px",
                  resize: "vertical",
                  whiteSpace: "pre-wrap",
                }}
                placeholder={lg?.aboutbook || "Enter a description of the book..."}
              />
            </div>
          </div>
          <div className="d-flex mladd justify-content-center mt-4">
            <button
              className="text-white subbtnmeet border-0 fs-18 fw600 rounded-1"
              style={{
                width: "135px",
                height: "44px",
                backgroundColor: "#62C0C7",
              }}
              onClick={addBookManually}
            >
              {lg?.addButton || lg?.add || "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Footer2 />
    </>
  );
};

export default BooksDetails;
